export default function Logo({ subtitle = "Independent Consultancy" }) {
  return (
    <div className="flex items-center gap-2.5 leading-none" data-testid="site-logo">
      <span className="grid place-items-center h-9 w-9 rounded-lg bg-[#3B82F6] text-white font-extrabold text-base shrink-0 shadow-sm">
        RA
      </span>
      <span className="flex flex-col">
        <span className="text-lg font-extrabold tracking-tight text-white">Radio App Consultancy</span>
        <span className="text-[10px] tracking-[0.2em] text-white/55 font-medium uppercase mt-0.5">{subtitle}</span>
      </span>
    </div>
  );
}
